"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFactory = void 0;
const CreateUserRequest_1 = require("../sub-clients/users/model/CreateUserRequest");
const Account_1 = require("../sub-clients/accounts/model/Account");
class UserFactory {
    static sample(user = {}) {
        const userId = user.id || `${user.firstName}-id` || `user-id`;
        return {
            id: userId,
            firstName: user.firstName || 'blub',
            lastName: user.lastName || 'blub',
            email: user.email || 'blipidy',
            features: user.features || {
                BO_WEB_APP_PRICES: true,
                LTI_AGE_FILTER: true,
                BO_WEB_APP_REQUEST_TRIMMING: false,
                BO_WEB_APP_REQUEST_ADDITIONAL_EDITING: false,
            },
            account: user.account || {
                id: 'account-id',
                name: 'account name',
                marketingInformation: { companySegments: ['EdTech'] },
                products: [Account_1.Product.LIBRARY],
                type: Account_1.AccountType.STANDARD,
                createdAt: new Date('2024-03-05T08:38:50.971544Z'),
                logoUrl: 'www.logo.com',
            },
            links: user.links || {},
            jobTitle: user.jobTitle || undefined,
            audiences: user.audiences || undefined,
            desiredContent: user.desiredContent || undefined,
            discoveryMethods: user.discoveryMethods || undefined,
            accessExpiresOn: user.accessExpiresOn || undefined,
        };
    }
    static sampleCreateRequest(request = {}) {
        return {
            email: request.email || 'bob@email.com',
            firstName: request.firstName || 'Bob',
            lastName: request.lastName || 'Smith',
            accountId: request.accountId || 'account-id',
            type: request.type || CreateUserRequest_1.UserType.webAppUser,
            permissions: request.permissions || {
                canOrder: false,
                canManageUsers: false,
            },
        };
    }
}
exports.UserFactory = UserFactory;
//# sourceMappingURL=UserFactory.js.map